import React from 'react';
import { Box, Modal } from '@mui/material';

const CustomModal = ({ open, onClose, children, sx, onBlur = () => {} }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
      onBlur={onBlur}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: {
            xs: '90%',
            sm: '80%',
            md: '60%',
            lg: '50%',
            xl: '40%',
          },
          maxWidth: '800px',
          bgcolor: 'background.paper',
          borderRadius: '20px',
          border: 'none',
          '&:focus-visible': {
            outline: 'none',
          },
          '@media (min-width: 992px)': {
            '--bs-modal-width': '800px',
            width: 'var(--bs-modal-width)',
          },
          ...sx,
        }}
      >
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
